import React from 'react';
import { PersonVariant, QDotSeparator, QText } from '../index';
import { PersonStatus } from './Person';
import { QBox, QFlex } from '../../QLayouts';

type QPersonActionTypeAndTimestampProps = {
  status: PersonStatus;
  variant?: PersonVariant;
  showPendingStatus?: boolean;
  actionTimestamp?: string;
};

const actionTextMapping: Record<PersonStatus, string> = {
  default: '',
  pending: 'Pending',
  approved: 'Approved',
  declined: 'Declined',
  reviewed: 'Reviewed',
  added: 'Added',
  removed: 'Removed',
  commented: 'Commented',
  edited: 'Edited',
  versioned: 'Versioned',
  changedStatus: 'Changed status',
  markedResolved: 'Marked as resolved',
  generated: 'Generated',
};

export const QPersonActionTypeAndTimestamp: React.FC<
  QPersonActionTypeAndTimestampProps
> = ({ status, variant = 'default', showPendingStatus, actionTimestamp }) => {
  const showStackedVariantWithActionTimestamp =
    variant === 'stacked' && actionTimestamp;

  if (status === 'pending') {
    return showPendingStatus ? (
      <QText fontSize="sm" color="gray.500">
        {actionTextMapping[status]}
      </QText>
    ) : null;
  }

  if (status === 'default') {
    return actionTimestamp ? (
      <QText fontSize="sm" color="gray.500">
        {actionTimestamp}
      </QText>
    ) : null;
  }

  if (showStackedVariantWithActionTimestamp) {
    return (
      <QFlex direction="column">
        <QText fontSize="sm" color="gray.500">
          {actionTextMapping[status]}
        </QText>
        <QText fontSize="sm" color="gray.500">
          {actionTimestamp}
        </QText>
      </QFlex>
    );
  }

  return actionTimestamp ? (
    <QFlex direction="row" alignItems="center">
      <QText fontSize="sm" color="gray.500">
        {actionTextMapping[status]}
      </QText>
      <QBox mx={1}>
        <QDotSeparator />
      </QBox>
      <QText fontSize="sm" color="gray.500">
        {actionTimestamp}
      </QText>
    </QFlex>
  ) : null;
};
